import { useEffect, useState } from 'react';
import moment from 'moment';
import { Table } from 'antd';
import { Company } from 'utils/enums';
import { getDisplayCompanyId } from 'utils/helpers';
import notifier from 'utils/notifier';

interface SearchMemberResultTable {
  dataSource: any[],
  setPage(page: string): void,
  setClaim(record: any): void,
  isSearching: boolean,
  setAccessErrors(errors: string[]): void;
};

const SearchMemberResultTable = (props: SearchMemberResultTable) => {

  const DEFAULT_PAGE_NUM = 1;
  const DEFAULT_PAGE_SIZE = 20;
  const [page, setPage] = useState(DEFAULT_PAGE_NUM);

  useEffect(() => {
    setPage(DEFAULT_PAGE_NUM);
  }, [props.dataSource]);

  const columns = [
    {
      title: 'IPA',
      key: 'RmiCompanyId',
      dataIndex: 'RmiCompanyId',
      render: (text: string) => getDisplayCompanyId(text)
    },
    {
      title: 'Member ID',
      key: 'RmiMembId',
      dataIndex: 'RmiMembId',
      sorter: (a: any, b: any) => a.RmiMembId.localeCompare(b.RmiMembId),
      render: (text: string, record: any) => <a onClick={() => record.RmiHpCode === 'BSPP' ? notifier.error('Patient is a Blue Shield PPO member - please foward claim to Blue Shield directly', '', 5)  : setDetailPage(record)}>{text}</a>
    },
    {
      title: 'Last Name',
      key: 'RmiLastName',
      dataIndex: 'RmiLastName',
      sorter: (a: any, b: any) => a.RmiLastName.localeCompare(b.RmiLastName),
    },
    {
      title: 'First Name',
      key: 'RmiFirstName',
      dataIndex: 'RmiFirstName',
      sorter: (a: any, b: any) => a.RmiFirstName.localeCompare(b.RmiFirstName),
    },
    {
      title: 'Gender',
      key: 'RmiSex',
      dataIndex: 'RmiSex',
    },
    {
      title: 'Date Of Birth',
      key: 'RmiBirth',
      dataIndex: 'RmiBirth',
      sorter: (a: any, b: any) => a.RmiBirth.localeCompare(b.RmiBirth),
      render: (text: string) => moment(text).format('MM/DD/YYYY')
    },
    {
      title: 'Language',
      key: 'RmiLanguage',
      dataIndex: 'RmiLanguage',
      sorter: (a: any, b: any) => a.RmiLanguage.localeCompare(b.RmiLanguage),
    },
    {
      title: 'Health Plan',
      key: 'RmiHpName',
      dataIndex: 'RmiHpName',
    },
    {
      title: 'Option',
      key: 'RmiOpt',
      dataIndex: 'RmiOpt',
    },
    {
      title: 'Start Date',
      key: 'RmiStartDate',
      dataIndex: 'RmiStartDate',
      render: (text: string) => moment(text).format('MM/DD/YYYY')
    },
    {
      title: 'Term Date',
      key: 'RmiEndDate',
      dataIndex: 'RmiEndDate',
      render: (text: string) => text ? moment(text).format('MM/DD/YYYY') : ''
    },
  ];

  const setDetailPage = (record: any) => {
    const errors = memberAccess(record);
    if (errors.length === 0) {
      props.setPage('claim-detail');
      props.setClaim(record);
    } else {
      props.setAccessErrors(errors);
    }
  };

   //TODO - Ported the validation logics over from legacy but temporary commenting out some of the validation to limit scope to hotfix for CRCAMC - workitem 30459
   const memberAccess = (member: any) => {
    let msgList: string[] = [];
    // let startDate = null;
    // let endDate = null;

    if (member.RmiHpCode == "HNCC") {
      msgList.push("Health Net Covered California member claims should be forwarded to Health Net directly:  Health Net Commercial Claims, P.O. Box 9040, Farmington, MO 63640-9040");
      return msgList;
    }

    //TODO - test later
    //convert member's end/start date to correct timezone
    // if (member.RmiEndDate) {
    //   const tDate = member.RmiEndDate.split("T");
    //   endDate = new Date(tDate[0]).setHours(0, 0, 0, 0);
    //   //new Date obj is decreasing by 1 day, so here we add it back
    //   endDate = new Date(endDate + 24 * 60 * 60 * 1000);
    //  }

    //TODO - test later
    // if (member.RmiEndDate && props.dos != null && moment(props.dos) > moment(member.RmiEndDate)) {
    //   msgList.push("Date of service must be on or before member's termed date.");
    //   return;
    // }

    //TODO - test later
    // if ("BSPP" == member.RmiHpCode) {
    //   msgList.push("Patient is a Blue Shield PPO member - please forward claim to  Blue Shield directly");
    //   return;
    // }

    //TODO - test later
    // else if (member.RmiCompanyId !== search.CompanyId) {
    //   msgList.push("Please select a provider with the same IPA as the member.");
    //   return;
    // }

    //TODO - test later
    // else if (member.RmiHpCode == "HNCC") {
    //   msgList.push("Health Net Covered California member claims should be forwarded to Health Net directly:  Health Net Commercial Claims, P.O. Box 9040, Farmington, MO 63640-9040");
    //   return;
    // }

    //TODO - test later
    //01/03/2018 per Darin's email
    // else if (member.RmiCompanyId == "AHC" && member.RmiHpCode == "CHPS" && moment(props.dos) < moment("1/1/2018")) {
    //   msgList.push("For Central Health Plan Members:  For date of service prior to 01/01/2018, please submit Accountable Health Care member claims directly to Central Health MSO. You may contact Central Health MSO at 626-388-2300.");
    //   return;
    // }

    //TODO - test later
    // else if (member.RmiCompanyId == "AHC" && member.RmiHpCode == "CFS" && moment(props.dos) < moment("1/1/2018")) {
    //   msgList.push("For Care1st Senior Members: For date of service prior to 01/01/2018, please submit Accountable Health Care member claims directly to Care1st Health Plan. You may contact Care1st Health Plan at 323-889-6638.");
    //   return;
    // }

    //else if (member.RmiCompanyId == "APAACO") {
    //  errorMsg = true;
    //  msgList.push("For APAACO Members:  Please submit member claims directly to ..."); //TODO:  AWAITING specific verbage
    //  return;
    //}

    return msgList;
  }

  return (
    <Table
      columns={columns}
      dataSource={props.dataSource}
      rowKey={'RmiMembKeyId'}
      scroll={{ scrollToFirstRowOnChange: true, x: true }}
      loading={props.isSearching}
      pagination={{
        current: page,
        position: ['bottomCenter'],
        showSizeChanger: true,
        defaultPageSize: DEFAULT_PAGE_SIZE,
        total: props.dataSource.length,
        hideOnSinglePage: true,
        onChange: (num: number) => {
          setPage(num);
        }
      }}
    />
  );
};

export default SearchMemberResultTable;